import { CloseCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  Form,
  FormInstance,
  Input,
  Modal,
  Row,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import iconSearch from "../../../assets/images/booking/icon-search.svg";
import "../../../assets/styles/desktop/busBooking.scss";
import useDebounce from "../../../hooks/useDebounce";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { setReloadDetail } from "../../../redux/slice/authSlice";
import { resetAssistBooking } from "../../../redux/slice/bookings/getAssistBookingSlice";
import {
  getPrintInfoBooking,
  resetPrintTicket,
  setIsPrintTicket,
} from "../../../redux/slice/bookings/printTicketSlice";
import ModalPrintTicket from "../tickets/ModalPrintTicket";

const PrintMultiBookingModal: React.FC<any> = ({
  modalOpen,
  onCancel,
  onOk,
  searchDateBooking,
  listBooking,
}) => {
  const { loading, dataPrintTicket } = useAppSelector(
    (state) => state.printTicket
  );
  const [isModalOpen, setIsModalOpen] = useState(modalOpen);
  const [openModalPrint, setOpenModalPrint] = useState(false);
  const [listDataPrintTicket, setListDataPrintTicket] = useState([]);
  const [formSearch]: [FormInstance] = Form.useForm();
  const dispatch = useAppDispatch();
  const watchKeyword = Form.useWatch("keyword", formSearch);
  const keywordSearch = useDebounce(watchKeyword, 800);

  useEffect(() => {
    setIsModalOpen(modalOpen);
  }, [modalOpen]);

  const modalHandleOk = () => {
    onOk();
  };
  const modalHandleCancel = () => {
    onCancel();
    formSearch.resetFields();
    dispatch(resetAssistBooking());
    dispatch(resetPrintTicket());
  };

  const handleClearSearch = () => {
    formSearch.setFieldValue("keyword", "");
  };

  const cancelModalPrint = () => {
    dispatch(setReloadDetail());
    setOpenModalPrint(false);
    setListDataPrintTicket([]);
  };
  const scrollToErrorField = (errorFields: any) => {
    const [firstErrorField] = errorFields;
    if (firstErrorField) {
      formSearch.scrollToField(firstErrorField.name);
    }
  };

  const onFinish = (values: any) => {
    const selectedCodes = values.ticket_code || [];
    const matchedTickets = dataPrintTicket?.filter((ticket: any) =>
      selectedCodes?.includes(ticket.ticket_code)
    );
    dispatch(setIsPrintTicket(true));
    setListDataPrintTicket(matchedTickets);
    setOpenModalPrint(true);
  };

  useEffect(() => {
    if (isModalOpen) {
      dispatch(
        getPrintInfoBooking({
          schedule_id: +listBooking?.schedule?.id,
          depart_date: searchDateBooking,
          keyword: keywordSearch,
        })
      );
    }
  }, [keywordSearch, listBooking, searchDateBooking, dispatch, isModalOpen]);

  return (
    <Modal
      open={isModalOpen}
      onOk={modalHandleOk}
      onCancel={modalHandleCancel}
      centered
      footer={[]}
      width={700}
      title={
        <div className="border-booking-title">
          <h3 className="fs-18 fw-600 text-middle-black">In vé</h3>
        </div>
      }
      maskClosable={false}
      className="modal-bus-booking"
    >
      <Spin spinning={loading}>
        <p className="fs-16 fw-500 text-blue mt-1">Chọn vé bạn muốn in:</p>
        <Card className="card-modal-booking mt-1 assist">
          <Form
            layout="vertical"
            className="form-booking-multi"
            form={formSearch}
            onFinish={onFinish}
            autoComplete="off"
            validateTrigger="onSubmit"
            labelAlign={"left"}
            labelWrap
            onFieldsChange={(allFields) => {
              scrollToErrorField(
                allFields.filter(
                  (field) => field.errors && field.errors.length > 0
                )
              );
            }}
          >
            <div className="ticket-info-booking-block mt-2">
              <div className="bg-ticket">
                <span className="fs-16 fw-600">Danh sách các mã vé</span>
              </div>
              <Form.Item
                name="keyword"
                style={{ width: "300px" }}
                className="search-print-booking-input"
              >
                <Input
                  placeholder="Nhập mã vé"
                  prefix={
                    <img className="mr-1" alt="icon search" src={iconSearch} />
                  }
                  className="rounded-lg "
                  suffix={
                    watchKeyword ? (
                      <CloseCircleOutlined
                        className="cursor-pointer"
                        onClick={handleClearSearch}
                      />
                    ) : (
                      ""
                    )
                  }
                />
              </Form.Item>
              <Form.Item
                name={"ticket_code"}
                className="segment-item-block print"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập mã vé",
                  },
                ]}
              >
                <Checkbox.Group className="d-flex flex-col gap-y-12 payment-checkbox-group print seat-available">
                  {dataPrintTicket?.length
                    ? dataPrintTicket?.map((ticket: any, index: number) => (
                        <Checkbox
                          value={ticket?.ticket_code}
                          key={index}
                          className="available-seat-block"
                        >
                          <div className="available-seat-item">
                            <div>
                              <p>{`Mã vé: ${ticket?.ticket_code} - ${ticket?.customer?.name} (${ticket?.customer?.phone})`}</p>
                              <p className="fs-13 text-success fw-500">
                                {`${ticket?.start_location} - ${ticket?.end_location}`}
                              </p>
                            </div>
                          </div>
                        </Checkbox>
                      ))
                    : ""}
                </Checkbox.Group>
              </Form.Item>
            </div>
            <Row
              className="d-flex justify-content-end mt-3 w-100"
              style={{ columnGap: "10px" }}
            >
              <>
                <Button
                  key="cancel"
                  className="w-150 h-btn-44 btn-back fs-16 fw-600 t-b rounded-lg"
                  htmlType="button"
                  onClick={() => modalHandleCancel()}
                >
                  Đóng
                </Button>
                <Button
                  key="submit"
                  className=" w-150 h-btn-44 btn-success text-white fs-16 fw-600 rounded-lg mr-0"
                  htmlType="submit"
                  onClick={() => modalHandleOk()}
                >
                  In vé
                </Button>
              </>
            </Row>
          </Form>
        </Card>
        <ModalPrintTicket
          modalOpen={openModalPrint}
          onCancel={cancelModalPrint}
          onOk={() => setOpenModalPrint(false)}
          listBooking={listBooking}
          // listBookingDetail={listBookingDetail}
          dataPrintTicket={listDataPrintTicket}
        />
      </Spin>
    </Modal>
  );
};
export default PrintMultiBookingModal;
